import { render } from "./AuctionPage.vue?vue&type=template&id=ed660840&scoped=true"
import script from "./AuctionPage.vue?vue&type=script&lang=js"
export * from "./AuctionPage.vue?vue&type=script&lang=js"

import "./AuctionPage.vue?vue&type=style&index=0&id=ed660840&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed660840"]])

export default __exports__